import React from 'react';
import { Alert } from 'antd';
import { WifiOutlined } from '@ant-design/icons';
import { usePWA } from '../../Context/PWAContext';
import './index.scss';

const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null;
  }

  return (
    <div className="offline-indicator">
      <Alert
        message="You're offline"
        description="Some features may not be available. Please check your internet connection."
        type="warning"
        icon={<WifiOutlined />}
        showIcon
        closable={false}
      />
    </div>
  );
};

export default OfflineIndicator; 